export default __webpack_public_path__ + "static/media/empty-cart.4d0154b0.webp";